var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"custom",attrs:{"items":_vm.items,"label":_vm.$t('core.titlebar.granularitySelector'),"hide-details":""},model:{value:(_vm.selectedGranularity),callback:function ($$v) {_vm.selectedGranularity=$$v},expression:"selectedGranularity"}})
}
var staticRenderFns = []

export { render, staticRenderFns }